export interface Rule {
  birth: Set<number>;
  survival: Set<number>;
}

export const PRESETS: Record<string, string> = {
  'Game of Life': 'B3/S23',
  'HighLife': 'B36/S23',
  'Seeds': 'B2/S',
  'Maze': 'B3/S12345',
  'Day & Night': 'B3678/S34678',
  'Life without Death': 'B3/S012345678',
  'Diamoeba': 'B35678/S5678',
  'Replicator': 'B1357/S1357',
  '2x2': 'B36/S125',
  'Morley': 'B368/S245',
  'Anneal': 'B4678/S35678',
};

export const PRESET_DESCRIPTIONS: Record<string, string> = {
  'Game of Life': 'Classic rule. Stable patterns: gliders, blinkers, still lifes.',
  'HighLife': 'Similar to Life but with more replicators and patterns.',
  'Seeds': 'Very chaotic. Births on 2 neighbors, no survival. Expands rapidly.',
  'Maze': 'Fills space like a maze. Creates intricate fractal-like patterns.',
  'Day & Night': 'Complex rule with symmetric birth/survival conditions.',
  'Life without Death': 'Cells never die. Grows endlessly until grid fills.',
  'Diamoeba': 'Produces amoeba-like expanding patterns. Chaotic behavior.',
  'Replicator': 'Self-replicating structures. Creates fractal shapes.',
  '2x2': 'Produces rectangular growing patterns.',
  'Morley': 'Exotic rule creating complex moving structures.',
  'Anneal': 'Very active rule. Creates intricate patterns and structures.',
};

export function parseRule(input: string): Rule | null {
  const normalized = input.trim().toUpperCase();
  const match = normalized.match(/^B(\d*)\/?S(\d*)$/);
  if (!match) return null;

  const birthDigits = match[1];
  const survivalDigits = match[2];

  const birth = new Set<number>();
  const survival = new Set<number>();

  for (const ch of birthDigits) {
    const n = parseInt(ch);
    if (n < 0 || n > 8) return null;
    birth.add(n);
  }

  for (const ch of survivalDigits) {
    const n = parseInt(ch);
    if (n < 0 || n > 8) return null;
    survival.add(n);
  }

  return { birth, survival };
}

export function ruleToString(rule: Rule): string {
  const birthArr = Array.from(rule.birth).sort();
  const survivalArr = Array.from(rule.survival).sort();
  return `B${birthArr.join('')}/S${survivalArr.join('')}`;
}
